import { getSession } from "./jwt";

export default function getPrepareedRTKAuthHeaders(headers) {
  const token = getSession();
  if (token) {
    headers.set("authorization", `Bearer ${token}`);
  }
  return headers;
}
